import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import LinearProgress from '@mui/material/LinearProgress';
import { AppHeader } from './components/AppHeader';
import { AppFooter } from './components/AppFooter';

const HomePage = lazy(() => import('./pages/HomePage').then((m) => ({ default: m.HomePage })));
const SectionLandingPage = lazy(() => import('./pages/SectionLandingPage').then((m) => ({ default: m.SectionLandingPage })));
const DocPageView = lazy(() => import('./pages/DocPageView').then((m) => ({ default: m.DocPageView })));
const RoadmapPage = lazy(() => import('./pages/RoadmapPage').then((m) => ({ default: m.RoadmapPage })));
const FeatureRequestsPage = lazy(() => import('./pages/FeatureRequestsPage').then((m) => ({ default: m.FeatureRequestsPage })));
const CommunityPage = lazy(() => import('./pages/CommunityPage').then((m) => ({ default: m.CommunityPage })));
const SearchPage = lazy(() => import('./pages/SearchPage').then((m) => ({ default: m.SearchPage })));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })));

export function App(): JSX.Element {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppHeader />
      <Container component="main" maxWidth="lg" sx={{ flex: 1, py: { xs: 4, md: 6 } }}>
        <Suspense fallback={<LinearProgress sx={{ mt: 2 }} />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/roadmap" element={<RoadmapPage />} />
            <Route path="/feature-requests" element={<FeatureRequestsPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/:sectionSlug" element={<SectionLandingPage />} />
            <Route path="/:sectionSlug/:pageSlug" element={<DocPageView />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </Container>
      <AppFooter />
    </Box>
  );
}
